export default {"src":"/_next/static/media/reload-white.c03b5082.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};